import {useCallback, useState} from 'react';
import {Button, CircularProgress} from '@mui/material';
import {apiPost} from '../../../../../axiosConfig';
import DialogAttention from '../../../../../components/dialogs/DialogAttention';
import {defaultApiState} from '../../../../../dto/Html.dto';
import DialogApiRequestStatus from '../../../../../components/dialogs/DialogApiRequestStatus';

const StationRefreshRadioPlaylists = ({
  company_id,
  station_id,
  station_name,
}: {
  company_id: number;
  station_id: number;
  station_name: string;
}) => {
  const [loading, setLoading] = useState(false);
  const [apiState, setApiState] = useState(defaultApiState);
  const [isConfirm, setIsConfirm] = useState<boolean>(false);

  const openConfirmDialog = () => {
    setIsConfirm(true);
  };

  const closeConfirmDialog = () => {
    setIsConfirm(false);
    setApiState(defaultApiState);
  };

  const handleClick = useCallback(() => {
    setLoading(true);
    apiPost(
      `/v1/company/${company_id}/station/${station_id}/refresh-radio-playlist`,
    )
      .then(res => {
        setIsConfirm(false);
        setApiState({
          status: 'success',
          error: null,
          successMsg: res.data.message,
        });
        setLoading(false);
      })
      .catch(error => {
        setApiState({status: 'error', error, successMsg: ''});
        setLoading(false);
      });
  }, [company_id, station_id]);

  return (
    <>
      <Button
        variant='outlined'
        disabled={loading}
        onClick={openConfirmDialog}
        startIcon={loading ? <CircularProgress size={20} /> : null}>
        Hard Reset
      </Button>
      <DialogAttention
        isOpen={isConfirm}
        station_name={station_name}
        closeConfirmDialog={closeConfirmDialog}
        handleClick={handleClick}
      />
      {apiState.status !== '' && (
        <DialogApiRequestStatus
          onEdit={() => setApiState(defaultApiState)}
          onRetry={handleClick}
          onClose={closeConfirmDialog}
          apiState={apiState}
        />
      )}
    </>
  );
};
export default StationRefreshRadioPlaylists;
